//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProblemRectificationDrawer from "./modules/ProblemRectificationDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList } from '@/api/api';
export default {
  name: 'ProblemRectificationList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    ProblemRectificationDrawer: ProblemRectificationDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/problem/rectification',
      pageTitle: '问题整改',
      isorter: {
        column: 'check_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center'
      }, {
        dataIndex: 'checkCompany',
        colName: 'check_company',
        title: '检查单位',
        align: 'center'
      }, {
        dataIndex: 'principledIssues',
        colName: 'principled_issues',
        title: '疑似原则性问题',
        align: 'center'
      }, {
        dataIndex: 'keyIssues',
        colName: 'key_issues',
        title: '重点关注问题',
        align: 'center'
      }, {
        dataIndex: 'checkDate',
        colName: 'check_date',
        title: '检查时间',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      userTree: [] //人员信息

    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {
    this.loadTreeList();
    this.queryParam.status = 1;
  },
  computed: {},
  methods: {
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    onDateCheckDate: function onDateCheckDate(value, dateArray) {
      this.queryParam.checkDateStart = dateArray[0];
      this.queryParam.checkDateEnd = dateArray[1];
    }
  }
};